import createCache from '@emotion/cache'
import type { EmotionCache } from '@emotion/react'
import { IS_SSR } from '@src/lib/server-side-rendering.tsx'

/**
 * Creates a new Emotion cache instance with the project's custom key.
 * Using a consistent key ('sco') ensures that class names generated during
 * SSR match those generated on the client (e.g. `sco-fsbecf` vs `css-fsbecf`),
 * preventing hydration mismatches for Chakra UI components and other
 * emotion-generated styles.
 *
 * `speedy: true` enables faster style insertion (using <style> tags on SSR).
 */
export function createEmotionCache(): EmotionCache {
  return createCache({
    key: 'css',
    speedy: !!IS_SSR,
    prepend: false,
  })
}
